import { Box, Button, Typography } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router";
import EmptyInvestmentsImg from "../../assets/images/empty-investments.svg";
import BuyGainModel from "../Modals/BuyGainModel";
import useStyles from "../Styles/ShowProjectStyles";

export default function EmptyInvestments() {
  const [openBuy, setOpenBuy] = useState<boolean>(false);
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box
      my={3}
      display="flex"
      justifyContent={"center"}
      alignItems="center"
      flexDirection={"column"}
      textAlign="center"
    >
      <img src={EmptyInvestmentsImg} alt="Empty investments" style={{maxWidth:"90%"}} />
      <Typography className={classes.emptyTitle}>No investments</Typography>
      <Typography variant="body1" style={{ maxWidth: 365 }}>
        You haven’t made any investments yet. Projects you invest in will
        appear here.
      </Typography>
      <Box marginTop={"2rem"}>
        <Button
         variant="contained"
         color="secondary"
         onClick={()=> history.push('/deals')}
         className={classes.exploreBtn}
        >
          Explore deals
        </Button>
        <Button
          variant="contained"
          color="secondary"
          className={classes.buyGainsButton}
          onClick={() => {
            setOpenBuy(true);
          }}
        >
          Buy GAINS
        </Button>
      </Box>
      {openBuy && <BuyGainModel open={openBuy} setOpen={setOpenBuy} />}
    </Box>
  );
}
